
<div :class="[jel_getClassObject(content)]" class="w-100 tableau">
  <!-- TODO: Non-testé -->
  <div v-if="content.enteteTableau" class="enteteTableau" :style="styleObjectEntetePied">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8 no-float vertical-top">
          <div v-html="content.enteteTableau"></div>
        </div>
      </div>
    </div>
  </div>

  <table
    class="table-vertical table-striped"
    :style="content.couleurFondEntete && $mq !== 'xs' && $mq !== 'sm' ? borderTable : ''"
  >
    <thead>
      <tr class="entete">
        <th
          v-for="unElement in splitEntete"
          :key="unElement.id"
          :style="{ 'background-color': content.couleurFondEntete }"
        >
          <span>
            {{ unElement }}
          </span>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="uneLigneContenu in splitTableContent()"
        :key="uneLigneContenu.id"
        class="ligne mobile desktop"
      >
        <td
          v-for="(unElement, index2) in uneLigneContenu"
          :key="unElement.id"
          :class="[splitEntete[index2]]"
          :data-th="splitEntete[index2]"
        >
          <span>
            <template v-if="splitFormatColonne[index2] == 'Majuscule'">
              <span class="majuscule">{{ unElement }}</span>
            </template>
            <template
              v-else-if="
                splitFormatColonne[index2] == 'DateHeure' ||
                splitFormatColonne[index2].startsWith('DateHeure|')
              "
            >
              {{ formatDateHeure(unElement, splitFormatColonne[index2]) }}
            </template>
            <template v-else-if="splitFormatColonne[index2] == 'Argent'">
              <money-format
                :value="Number(unElement)"
                :locale="$i18n.locale + '-CA'"
                currency-code="CAD"
                :subunit-value="true"
              ></money-format>
            </template>
            <template v-else-if="splitFormatColonne[index2] == 'DAM'">
              <img
                v-lazy="`${mixinEnvironnement_damPath}${unElement}`"
                :alt="'Image' + splitEntete[index2]"
              />
            </template>
            <template v-else-if="splitFormatColonne[index2] == 'BingoSalle'">
              <div>{{ getTitreSalleByIdSalleNyx(unElement) }}</div>
            </template>
            <template v-else>
              {{ unElement }}
            </template>
          </span>
        </td>
      </tr>
    </tbody>

    <tfoot>
      <tr class="footer" :style="{ 'background-color': content.couleurFondEntete }">
        <td :colspan="splitEntete.length"></td>
      </tr>
    </tfoot>
  </table>

  <!-- TODO: Non-testé -->
  <div v-if="content.piedTableau" class="piedTableau" :style="styleObjectEntetePied">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8 no-float vertical-top">
          <div v-html="content.piedTableau"></div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!showMoreResults" class="text-center mt-1 mt-md-4">
    <button
      class="btn graphik_bold btn_bingo_theme disableThemeHover voir_plus_btn"
      @click="showMoreResults = !showMoreResults"
    >
      <!-- TODO: Definir couleur en focntion du theme Bingo -->
      {{ content.texteBouton ? content.texteBouton : $t('messageComponent.boutonPlus') }}
    </button>
  </div>
</div>
